import { render, staticRenderFns } from "./ProfileExtraInfo.vue?vue&type=template&id=2014fb94&scoped=true&"
import script from "./ProfileExtraInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileExtraInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileExtraInfo.vue?vue&type=style&index=0&id=2014fb94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2014fb94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2014fb94', component.options)
    } else {
      api.reload('2014fb94', component.options)
    }
    module.hot.accept("./ProfileExtraInfo.vue?vue&type=template&id=2014fb94&scoped=true&", function () {
      api.rerender('2014fb94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/extra_info/ProfileExtraInfo.vue"
export default component.exports